// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"MenuIcon-module--menu-icon--bdW1Q","open":"MenuIcon-module--open--35NLA"};